"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VttThumbnails = void 0;
var player_base_1 = require("@24i/player-base");
var StaticThumbnails_1 = require("./StaticThumbnails");
var VttThumbnails = (function (_super) {
    __extends(VttThumbnails, _super);
    function VttThumbnails() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VttThumbnails.prototype.load = function (source) {
        return __awaiter(this, void 0, void 0, function () {
            var thumbnails, vttTrackUrl, response, contents, lines;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        thumbnails = undefined;
                        vttTrackUrl = VttThumbnails.findThumbnailTrack(source);
                        if (!vttTrackUrl) return [3, 3];
                        return [4, fetch(vttTrackUrl)];
                    case 1:
                        response = _a.sent();
                        return [4, response.text()];
                    case 2:
                        contents = _a.sent();
                        lines = contents.split('\n').map(function (line) { return line.trim(); });
                        thumbnails = VttThumbnails.parseVtt(lines, vttTrackUrl);
                        _a.label = 3;
                    case 3:
                        this.initialize(thumbnails);
                        return [2, this.isReady()];
                }
            });
        });
    };
    VttThumbnails.findThumbnailTrack = function (source) {
        if (!source || !source.textTracks)
            return null;
        for (var _i = 0, _a = source.textTracks; _i < _a.length; _i++) {
            var textTrack = _a[_i];
            if (textTrack.kind !== player_base_1.TrackKind.Thumbnails)
                continue;
            if (textTrack.mimeType && textTrack.mimeType !== player_base_1.MIME_TYPE.WEBVTT)
                continue;
            if (!textTrack.url)
                continue;
            return textTrack.url;
        }
        return null;
    };
    VttThumbnails.parseVtt = function (lines, baseUrl) {
        if (!VttThumbnails.isValidHeader(lines))
            return [];
        var thumbnails = [];
        var lineNumberHolder = { lineNumber: 2 };
        while (true) {
            var block = this.readBlock(lines, lineNumberHolder);
            if (block.length === 0)
                break;
            if (this.isSpecialBlock(block))
                continue;
            this.processTimestampBlock(block, baseUrl, thumbnails);
        }
        return thumbnails;
    };
    VttThumbnails.isValidHeader = function (lines) {
        return lines[0].startsWith('WEBVTT') && lines[1] === '';
    };
    VttThumbnails.readBlock = function (lines, lineNumberHolder) {
        var block = [];
        while (lineNumberHolder.lineNumber < lines.length) {
            var line = lines[lineNumberHolder.lineNumber];
            lineNumberHolder.lineNumber += 1;
            if (line) {
                block.push(line);
            }
            else {
                break;
            }
        }
        return block;
    };
    VttThumbnails.isSpecialBlock = function (block) {
        return block[0].startsWith('NOTE') || block[0].startsWith('STYLE');
    };
    VttThumbnails.processTimestampBlock = function (block, baseUrl, thumbnails) {
        var timestampLineIndex = block.findIndex(function (line) {
            return line.includes(' --> ');
        });
        if (timestampLineIndex < 0)
            return;
        var timestampMatch = this.timestampRegex.exec(block[timestampLineIndex]);
        if (!timestampMatch || !timestampMatch.length)
            return;
        var startTimestamp = VttThumbnails.makeTimestamp(timestampMatch[2], timestampMatch[3], timestampMatch[4], timestampMatch[6]);
        var endTimestamp = VttThumbnails.makeTimestamp(timestampMatch[8], timestampMatch[9], timestampMatch[10], timestampMatch[12]);
        var thumbnail = StaticThumbnails_1.StaticThumbnails.buildThumbnail(startTimestamp, endTimestamp, block[timestampLineIndex + 1], baseUrl);
        thumbnails.push(thumbnail);
    };
    VttThumbnails.makeTimestamp = function (hours, minutes, seconds, millis) {
        return (VttThumbnails.makeTimestampElement(hours, 3600000) +
            VttThumbnails.makeTimestampElement(minutes, 60000) +
            VttThumbnails.makeTimestampElement(seconds, 1000) +
            VttThumbnails.makeTimestampElement(millis, 1));
    };
    VttThumbnails.makeTimestampElement = function (input, multiplier) {
        if (!input)
            return 0;
        var result = Number(input);
        if (!Number.isFinite(result))
            return 0;
        return result * multiplier;
    };
    VttThumbnails.timestampRegex = new RegExp('^(([0-9]+):)?([0-9]+):([0-9]+)(.([0-9]+))? --> (([0-9]+):)?([0-9]+):([0-9]+)(.([0-9]+))?$');
    return VttThumbnails;
}(StaticThumbnails_1.StaticThumbnails));
exports.VttThumbnails = VttThumbnails;
//# sourceMappingURL=VttThumbnails.js.map